import { Input } from '@angular/core';
import { ConsolidatedPhoneReportComponent } from '../consolidated-phone-report/consolidated-phone-report.component';
import { DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { HttpService } from 'src/app/http.service';
import { filterBanksForDropdown, settingIsOn } from 'src/app/util/bank-usage.util';
import { GameLogComponent } from '../game-log/game-log.component';
import { PlayerGameLogComponent } from '../player-game-log/player-game-log.component';
import { ClipboardService } from 'ngx-clipboard';
import { PlayerFormComponent } from '../player-form/player-form.component';
import { PlayerTransactionHistoryComponent } from '../player-transaction-history/player-transaction-history.component';
import { AllGameLogComponent } from '../all-game-log/all-game-log.component';
import { PlayerProfitComponent } from '../player-profit/player-profit.component';
import { PlayerRemoveComponent } from '../player-remove/player-remove.component';
import { LuckyDrawModalComponent } from '../lucky-draw-modal/lucky-draw-modal.component';
import { UnknownPaymentFormComponent } from '../unknown-payment-form/unknown-payment-form.component';
import { DownlineDepositWithdrawModalComponent } from '../downline-deposit-withdraw-modal/downline-deposit-withdraw-modal.component';

@Component({
  selector: 'app-auto-topup-withdraw',
  templateUrl: './auto-topup-withdraw.component.html',
  styleUrls: ['./auto-topup-withdraw.component.scss']
})
export class AutoTopupWithdrawComponent implements AfterViewInit {
  @Input() consolidatedReportCompanyUuid = '';
  openConsolidatedReport() {
    const modal = this.ngbModal.open(ConsolidatedPhoneReportComponent, {size:'lg'});
    modal.componentInstance.playerUuid = this.player.uuid;
    modal.componentInstance.reportCompanyUuid = this.consolidatedReportCompanyUuid;
  }

  private readonly destroyRef = inject(DestroyRef);
  @ViewChild('search') search;
  @ViewChild("selectPlayerGameID") selectPlayerGameID: NgSelectComponent
  @ViewChild("payout") payout: NgSelectComponent
  @ViewChild("th") th: PlayerTransactionHistoryComponent;
  @ViewChild("th1") th1: PlayerTransactionHistoryComponent;

  public show_game_balance = false;
  public is_copy: boolean = false;
  public is_loading: any = false
  public is_loading_function: any = false
  public is_searching_player: any = false
  public is_loading_game: any = false
  public is_loading_player_game_id = false;
  public player_search;
  public company_uuid;
  public game_balance: any;
  public data: any = { process: 'topup' };
  public players: any = [];
  public games: any = [];
  public transfer_games: any = []
  public banks: any = [];
  // Deposit vs withdraw bank selectors split by setting_bank use_deposit/
  // use_withdraw flags (see bank-usage.util). banks stays the full list.
  public depositBanks: any = [];
  public withdrawBanks: any = [];
  public unknowns: any = []
  public player_banks: any = [];
  public player_ids: any = []
  public transfer_player_ids: any = []
  public player: any = {};
  public player_game: any = {};
  public copy_text: any;
  public copy_text_append: any;
  public referral_rate: any = 0;
  private current_company: any = {}
  public setting: any = {}
  public grantedPermissions: { [path: string]: any } = {};

  constructor(private http: HttpService, private ngbModal: NgbModal, private clipboardApi: ClipboardService, private route: ActivatedRoute) {
    this.company_uuid = this.http.getStaticSelectedCompany();
    this.current_company = this.http.getSelecetdCompanyDetail()
    this.loadPermissions();
    this.companySetting();
  }

  async loadPermissions() {
    const permission: any = await this.http.getHiddenPermission();
    this.grantedPermissions = permission && typeof permission === 'object' ? permission : {};
  }

  can(path: string) {
    return !!this.grantedPermissions[path];
  }


  ngAfterViewInit(): void {
    this.searchPlayerListener();
    // Deep-link support: Player Search links here with ?player=<uuid>
    // so the operator lands on this player already selected (no re-search).
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((p: any) => {
      if (p && p.player && this.data.player_uuid !== p.player) {
        this.preselectPlayer(p.player);
      }
    });
  }

  async preselectPlayer(uuid: string) {
    try {
      if (!uuid) { return; }
      let y: any = await this.http.post("/admin/player/get/v2", { player_uuid: uuid });
      if (!y || !y.uuid) { return; }
      this.players = [y];
      await this.selectPlayer(uuid);
    } catch (e) {
      // fall back to manual search if the player can't be pre-loaded
    }
  }

  searchPlayerListener() {
    try {
      this.search.valueChanges
        .pipe(takeUntilDestroyed(this.destroyRef), debounceTime(500))
        .pipe(distinctUntilChanged())
        .subscribe((v: any) => {
          if (!v || v.length < 3) {
            return;
          }
          this.searchPlayer(v)
        })
    } catch (error) {}
  }

  resetPlayer() {
    this.data = { process: 'topup' };
    this.player = {};
    this.player_game = {};
    this.players = [];
    this.player_search = null;
    setTimeout(() => { this.searchPlayerListener(); }, 100);
  }

  async companySetting() {
    let y: any = await this.http.post("/admin/company/setting");
    this.setting = y.setting;
  }

  async searchPlayer(data: any) {
    delete this.data.player_uuid;
    this.is_searching_player = true;
    this.players = await this.http.post("/admin/player/search", { search: data })
    this.is_searching_player = false;
  }

  async getUnknownPayment() {
    this.unknowns = await this.http.post("/admin/unknow-payment/get");
  }

  async selectPlayer(player_uuid) {
    this.player_search = null;
    this.data.player_uuid = player_uuid;
    this.data.player_game_id = null;
    this.data.game_id = null;

    this.player = this.players.find((v: any) => {
      return v.uuid == player_uuid;
    })

    this.referral_rate = parseFloat(this.player.referral_rate ?? this.current_company.referral_rate);

    await this.getBankDetail();
    await this.getGames();
  }

  async getBankDetail() {
    let y: any = await this.http.post("/admin/player/bank-detail", this.data)

    this.banks = y.banks;
    // Opt-in per company: hide "Do Not Show" (public=0) banks from the topup/withdraw
    // dropdowns while keeping the full list for the Bank Summary. Default OFF.
    const hideNonPublic = settingIsOn(this.setting && this.setting.panel_hide_nonpublic_banks);
    this.depositBanks = filterBanksForDropdown(this.banks, 'deposit', hideNonPublic);
    this.withdrawBanks = filterBanksForDropdown(this.banks, 'withdraw', hideNonPublic);
    this.player_banks = y.player_banks;

    this.getUnknownPayment();
  }

  async getGames() {
    if (this.games && this.games.length > 0) {
      return;
    }

    this.is_loading_game = true;
    this.games = await this.http.post("/admin/integrated-game")

    this.is_loading_game = false;
  }

  async getPlayerGameID() {
    this.copy_text_append = "";
    this.is_loading_player_game_id = true;

    this.changePlayerGameID();

    this.player_ids = await this.http.post("/admin/player-game-id-by-game-id", { game_id: this.data.game_id, player_uuid: this.data.player_uuid, status: 'all' })

    let f = this.games.find((v: any) => {
      return v.id == this.data.game_id;
    })

    if (f.copy_text) {
      this.copy_text_append = f.copy_text;
    }

    this.transfer_games = this.games.filter((v: any) => {
      return v.id != this.data.game_id;
    })

    this.is_loading_player_game_id = false;
  }

  async getTransferPlayerGameID() {

    this.is_loading_player_game_id = true;

    this.transfer_player_ids = await this.http.post("/admin/player-game-id-by-game-id", { game_id: this.data.transfer_game_id, player_uuid: this.data.player_uuid, status: 'all' })

    this.is_loading_player_game_id = false;

  }

  async addNewGameID() {
    this.is_loading_player_game_id = true;

    let rtn: any = await this.http.post("/admin/integrated-game/create-user", this.data);

    if (!rtn.status) {
      this.is_loading_player_game_id = false;

      this.http.notify(rtn.message)
      return;
    }

    this.player_ids = rtn.player_ids;

    this.data.player_game_id = rtn.created.id;
    this.is_loading_player_game_id = false;
    this.selectPlayerGameID.close();
  }

  changePlayerGameID() {
    this.game_balance = null;
    this.show_game_balance = false;

    if (!this.data.player_game_id) {
      return;
    }

    this.player_game = this.player_ids.find((v: any) => {
      return v.id === this.data.player_game_id;
    })

  }

  createNewAccount() {
    this.data.withdraw_to_account = "new"
    this.payout.close()
  }

  async getBalance() {
    this.changePlayerGameID();

    this.is_loading_function = true;

    let y: any = await this.http.post("/admin/integrated-game/check-balance", this.data);
    this.is_loading_function = false;

    if (!y.status && y.message) {
      this.http.notify(y.message)
      return;
    }

    this.show_game_balance = true;
    this.game_balance = y.balance;
  }

  async updateGameBalance() {
    await this.getBalance();
    this.data.withdraw = this.game_balance;
  }
  async topup() {
    if (this.is_loading_function) return;

    if ((!this.data.amount || this.data.amount <= 0) && !this.data.bonus) {
      this.data.amount = null;
      this.http.notify("Deposit Account or bonus be empty")
      return;
    }

    if (!this.data.deposit_bank && !this.data.topup_only) {
      this.http.notify("Select Deposit Account")
      return;
    }

    this.changePlayerGameID();

    this.is_loading_function = true;

    let y: any = await this.http.post("/admin/integrated-game/topup", this.data);
    this.is_loading_function = false;

    if (!y.status && y.message) {
      this.http.notify(y.message)
      return;
    }

    await this.generateCopy("Deposit: " + this.data.amount + "\nBonus: " + this.data.bonus + "\n")

    this.data = { game_id: this.data.game_id, player_uuid: this.data.player_uuid, player_game_id: this.data.player_game_id }

    await this.getBankDetail();
    await this.getGames();

    this.th.initTable();
    this.th1.initTable();

  }


  async withdraw() {
    if (this.is_loading_function) return;

    if (!this.data.full_withdraw && ((!this.data.withdraw || this.data.withdraw < 0) && this.data.withdraw !== 0)) {
      this.http.notify("Withdraw amount is required.")
      return;
    }

    if (!this.data.withdraw_only && (!this.data.withdraw_to_account || !this.data.withdraw_from_account)) {
      this.http.notify("Select Account to Withdraw or create new account")
      return;
    }

    if (!this.data.withdraw_only && (this.data.withdraw_to_account == 'new' && (!this.data.withdraw_bank || !this.data.withdraw_account_no))) {
      this.http.notify("Withdraw Bank Name & Account number are required.")
      return;
    } else {
    }

    if (!this.data.withdraw_only && this.data.enabled_finance_charge && this.data.finance_charge == undefined) {
      this.http.notify("Finance charge option are required.")
      return;
    }

    this.changePlayerGameID();

    this.is_loading_function = true;

    let y: any = await this.http.post("/admin/integrated-game/withdraw", this.data);

    this.is_loading_function = false;

    if (!y.status && y.message) {
      this.http.notify(y.message)
      return;
    }

    await this.generateCopy("Withdraw: " + y.amount + "\n")
    this.data = { game_id: this.data.game_id, player_uuid: this.data.player_uuid, player_game_id: this.data.player_game_id }

    await this.getBankDetail();

    this.th.initTable();
    this.th1.initTable();

  }

  async resetPassword() {
    this.is_loading_function = true;

    let y: any = await this.http.post("/admin/integrated-game/reset-password", this.data);

    this.is_loading_function = false;

    if (!y.status && y.message) {
      this.http.notify(y.message)
      return;
    }

    this.getPlayerGameID();

  }

  async disabledID() {

    this.changePlayerGameID();

    this.is_loading_function = true;

    let y: any = await this.http.post("/admin/integrated-game/disabled-id", this.data);

    this.is_loading_function = false;

    if (!y.status && y.message) {
      this.http.notify(y.message)
      return;
    }

    this.data.player_game_id = null;
    this.getPlayerGameID();

  }


  async endabledID() {

    this.changePlayerGameID();

    this.is_loading_function = true;

    let y: any = await this.http.post("/admin/integrated-game/enabled-id", this.data);

    this.is_loading_function = false;

    if (!y.status && y.message) {
      this.http.notify(y.message)
      return;
    }

    this.data.player_game_id = null;
    this.getPlayerGameID();

  }


  allBetLog() {
    let modal: any = this.ngbModal.open(AllGameLogComponent, { size: "xl" });
    modal.componentInstance.setData = this.data;

  }

  getGameLog() {
    let modal: any = this.ngbModal.open(PlayerGameLogComponent, { size: "xl" });
    modal.componentInstance.setPlayer = { code: this.player.code };
  }

  playerProfit() {
    if (this.consolidatedReportCompanyUuid) { this.openConsolidatedReport(); return; }
    let modal: any = this.ngbModal.open(PlayerProfitComponent, { size: "md" });
    modal.componentInstance.setPlaterUUID = this.player.uuid
  }

  downlineDepositWithdraw() {
    let modal: any = this.ngbModal.open(DownlineDepositWithdrawModalComponent, { size: "xl" });
    modal.componentInstance.playerUuid = this.player.uuid;
  }

  async copy() {

    if (this.copy_text) {
      this.copy_text = null
    } else {
      this.generateCopy();
    }
    this.is_copy = false;
  }

  async generateCopy(addon: any = false) {

    this.is_loading_function = true;

    await this.getBalance();

    let str: any = ""

    let date = new Date();
    //    str += "Date: " + ("0" + date.getDate()).slice(-2) + "-" + ("0" + (date.getMonth() + 1)).slice(-2) + "-" + date.getFullYear() + " " + date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds() + "\n";

    //   str += "Player:" + this.player.name + "\n";
    str += "Code:" + this.player.code + "\n";
    let game = this.games.find((v: any) => {
      return v.id == this.data.game_id
    })

    str += "Game: " + game.title + "\n"
    let player = this.player_ids.find((v: any) => {
      return v.id == this.data.player_game_id;
    });

    str += "ID: " + player.username + "\n"
    str += "PW: " + player.password + "\n"

    if (addon) {
      str += addon
    }

    str += "Last Bal: " + parseFloat(this.game_balance) + "\n"

    str += this.copy_text_append

    this.clipboardApi.copyFromContent(str)

    this.is_loading_function = false;

    if (addon) {
      this.is_copy = true;
    }

    this.copy_text = str;

  }

  addPlayer(player: any = null) {
    let modal: any = this.ngbModal.open(PlayerFormComponent, { size: "md", backdrop: 'static' });

    if (player && player.uuid) {
      modal.componentInstance.playerUUID = player.uuid
    }

    modal.componentInstance.fullwidth = true;
    modal.componentInstance.successEvent.subscribe(async (v: any) => {
      this.player = v;
      this.data.player_uuid = v.player_uuid;
      this.referral_rate = parseFloat(v.referral_rate ?? this.current_company.referral_rate);
      await this.getBankDetail();
      await this.getGames();
      modal.close();
    })

    modal.componentInstance.closeEvent.subscribe(async (v: any) => {
      modal.close();
    })

  }

  topupValueChange() {
    this.data.referral_commission = (this.data.amount * this.referral_rate) / 100;

    if (this.setting.credit_calculation_method && this.setting.credit_calculation_method == 'auto') {
      this.data.point = (this.data.amount * parseFloat(this.setting.credit_calculation_rate)) / 100;
    }

  }

  withdrawValueChange() {
    if (this.setting.credit_calculation_method && this.setting.credit_calculation_method == 'auto') {
      this.data.withdraw_point = -1 * (this.data.amount * parseFloat(this.data.credit_calculation_rate)) / 100;
    }
  }

  fcRateChange() {
    if (this.data.finance_charge == "true") {
      this.data.finance_charge_rate = this.setting.finance_charge_rate;
    } else {
      delete this.data.finance_charge_rate
    }
  }

  copyAccount() {

    let bank = this.player_banks.find((v: any) => {
      return v.id == this.data.withdraw_to_account
    })

    if (bank && bank.account) {
      this.clipboardApi.copyFromContent(bank.account)
    }
  }

  async claimUnknownPayment() {
    let y: any = await this.http.post("/admin/integrated-game/claim-unknown-payment", this.data);

    if (!y.status) {
      alert(y.message)
      return;
    }

    await this.getUnknownPayment();
  }

  topupOnlyChange() {
    if (this.data.topup_only) {
      delete this.data.amount
    }
  }

  copyUsername() {
    let games = this.player_ids.find((v: any) => {
      return v.id == this.data.player_game_id
    })

    if (games && games.username) {
      this.clipboardApi.copyFromContent(games.username)
    }

  }

  removePlayerID() {
    let modal: any = this.ngbModal.open(PlayerRemoveComponent, { size: "xs" });
    console.log(this.player_ids)
    modal.componentInstance.player_ids = this.player_ids;
    modal.componentInstance.saveEvent.subscribe((v: any) => {
      modal.close()
      this.getPlayerGameID()
    })
  }

  luckyDraw() {
    let modal: any = this.ngbModal.open(LuckyDrawModalComponent, { size: "xs" });
    modal.componentInstance.player = this.player;
    modal.componentInstance.saveEvent.subscribe((v: any) => {
      modal.close()
    })
  }

  getUnknownPaymentForm() {
    let modal: any = this.ngbModal.open(UnknownPaymentFormComponent, { size: "md" });
    modal.componentInstance.modal = true;
    modal.componentInstance.saveEvent.subscribe((v: any) => {
      modal.close()
    })
  }

  async transfer() {
    if (this.is_loading_function) return;
    if (!this.data.game_id || !this.data.player_game_id || !this.data.transfer_game_id || !this.data.transfer_player_game_id) {
      this.http.notify("Source and destination game accounts are required.");
      return;
    }
    if (String(this.data.player_game_id) === String(this.data.transfer_player_game_id)) {
      this.http.notify("Choose a different destination game account.");
      return;
    }
    this.is_loading_function = true;
    try {
      const y: any = await this.http.post("/admin/integrated-game/transfer", { ...this.data });
      if (!y || y.status !== true) {
        this.http.notify(y?.message || "Transfer result is unavailable. Check records before retrying.");
        return;
      }
      this.data.transfer_player_game_id = null;
      this.data.transfer_game_id = null;
      this.data.transfer = null;
      this.changePlayerGameID();
      this.th?.initTable();
      this.th1?.initTable();
      this.http.notify(y.message || "Transfer completed.");
    } catch (_) {
      this.http.notify("Transfer result is unavailable. Check records before retrying.");
    } finally {
      this.is_loading_function = false;
    }
  }
}
